// @flow

export { SimpleTextErrorMessage } from './simple-text-error-message';
